import { useState, useEffect } from 'react';
import { FaLinkedin, FaXTwitter, FaGithub, FaProductHunt } from 'react-icons/fa6';
import { SiCrunchbase } from 'react-icons/si';
import { BsGlobe } from 'react-icons/bs';
import './LiveIntelligence.css';

const LiveIntelligence = () => {
  const newsItems = [
    {
      logo: <FaLinkedin className="live-intelligence-logo logo-linkedin" />,
      source: "LinkedIn",
      title: "Founder has been building in stealth for 2 months.",
      time: "2m ago"
    },
    {
      logo: <BsGlobe className="live-intelligence-logo logo-web" />,
      source: "Hackathon Results",
      title: "College fintech hackathon winners posted.",
      time: "30m ago"
    },
    {
      logo: <FaProductHunt className="live-intelligence-logo logo-producthunt" />,
      source: "Product Hunt",
      title: "Founder just launched on Product Hunt.",
      time: "5m ago"
    },
    {
      logo: <FaXTwitter className="live-intelligence-logo logo-twitter" />,
      source: "X",
      title: "Founder posts a demo video.",
      time: "8m ago"
    },
    {
      logo: <SiCrunchbase className="live-intelligence-logo logo-crunchbase" />,
      source: "Crunchbase",
      title: "Preseed round of $300K added to profile.",
      time: "12m ago"
    },
    {
      logo: <FaGithub className="live-intelligence-logo logo-github" />,
      source: "GitHub",
      title: "Stealth founder open-sourced a new repo.",
      time: "15m ago"
    },
    {
      logo: <BsGlobe className="live-intelligence-logo logo-web" />,
      source: "Accelerator Announcement",
      title: "Pre-accelerator just accounced their fall cohort.",
      time: "30m ago"
    },
  ];

  // Keep track of 4 cards: 3 visible + 1 entering from bottom
  const [displayCards, setDisplayCards] = useState([
    { itemIndex: 0, position: 0, key: 'card-0' },
    { itemIndex: 1, position: 1, key: 'card-1' },
    { itemIndex: 2, position: 2, key: 'card-2' },
    { itemIndex: 3, position: -1, key: 'card-3' }, // Hidden, ready to enter
  ]);
  const [nextItemIndex, setNextItemIndex] = useState(4);

  useEffect(() => {
    const interval = setInterval(() => {
      // First, move all cards up one position
      setDisplayCards((prev) => {
        return prev.map((card) => {
          if (card.position === 2) {
            // Top card exits
            return { ...card, position: 3 };
          } else if (card.position === -1) {
            // New card enters at bottom
            return { ...card, position: 0 };
          } else {
            // All other cards move up one position
            return { ...card, position: card.position + 1 };
          }
        });
      });

      // After animation completes, reset the exited card with the next item
      setTimeout(() => {
        setDisplayCards((prev) => {
          return prev.map((card) => {
            if (card.position === 3) {
              return { ...card, itemIndex: nextItemIndex % newsItems.length, position: -1 };
            }
            return card;
          });
        });
        setNextItemIndex((prev) => prev + 1);
      }, 600); // Match transition duration
    }, 3000);

    return () => clearInterval(interval);
  }, [nextItemIndex, newsItems.length]);

  return (
    <section className="live-intelligence-section">
      <div className="live-intelligence-header">
        <span className="live-intelligence-badge">LIVE INTELLIGENCE</span>
        <h2 className="live-intelligence-title">
          Tracking the internet's <span className="live-intelligence-title-accent">pulse</span> for you.
        </h2>
        <p className="live-intelligence-subtitle">
          Cappuccino doesn't just tap into databases. It listens to the live web—news, commits, social spikes—to find companies the moment they happen.
        </p>
      </div>

      <div className="live-intelligence-cards">
        <div className="live-intelligence-carousel">
          {displayCards.filter(card => card.position >= 0 && card.position <= 2).map((card) => {
            const item = newsItems[card.itemIndex];
            return (
              <div
                key={card.key}
                className={`live-intelligence-card card-position-${card.position}`}
              >
                <div className="live-intelligence-card-header">
                  {item.logo}
                  <span className="live-intelligence-time">{item.time}</span>
                </div>
                <h3 className="live-intelligence-source">{item.source}</h3>
                <p className="live-intelligence-card-title">{item.title}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LiveIntelligence;
